import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { iconList } from "./iconList";

export default function IconDisplay({ iconId, colorCode, tooltip }) {
    const selected = iconList.find(icon => icon.id === iconId);
    if(selected && tooltip){
        return <Box sx={{ color: colorCode ?? "primary" }}><Tooltip title={<Typography style={{ whiteSpace: 'pre-line' }} fontSize="14px">{tooltip}</Typography>}>{selected.icon}</Tooltip></Box>
    }
    else if(selected && !tooltip){
        return <Box sx={{ color: colorCode ?? "primary" }}>{selected.icon}</Box>
    }
    return null;
}